import '../Containers/CommonStyles.css';
import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation, Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import logo from '../assets/img/CBRE_logo.svg';
import headerMobileImg from '../assets/img/mobile/MicrosoftTeams-image.png';
import Spinner from '../Components/Spinner/Spinner';
import useQuery from '../hooks/useQuery';
import * as constNames from '../models/constant';
import { Routes as AppRoutes } from '../models/routes';
import * as actionTypes from '../store/actions/index';
import { hasValidSurveyID } from '../utils/utils';

function MobileCoverPageComponent(props) {
  const [IsSpinner, SetIsSpinner] = useState(false);
  const query = useQuery();
  const { surveyId } = useParams();
  const location = useLocation();
  const history = useHistory();

  // const [prevRoute, setPrevRoute] = useState(null);

  const data = useSelector((state) => state?.optRed?.data);
  const pdfDownload = useSelector((state) => state?.comRed?.pdfDownload);
  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);
  const emails = useSelector((state) => state?.comRed?.displayMails);

  const dispatch = useDispatch();

  const isShortlisted = query.get(constNames.IS_SHORTLISTED);

  useEffect(() => {
    if (data && data?.dealId) {
      dispatch(actionTypes.flexpertEmailAction(data.dealId, 'CLIENT'));
    }
  }, [data, dispatch]);

  useEffect(() => {
    // if (!pdfDownload && hasValidSurveyID(surveyId)) {
    if (!pdfDownload && surveyId) {
      SetIsSpinner(true);
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, false));
    }
  }, [dispatch, isShortlisted, pdfDownload, surveyId]);

  useEffect(() => {
    if (Object.keys(currentDeal)?.length > 0) {
      SetIsSpinner(false);
    }
  }, [currentDeal]);

  const surveyData = data;

  const getSurveyName = () => {
    if (currentDeal?.['Target Market']) {
      return currentDeal?.['Target Market'];
    }
  };

  const goBack = () => {
    history.goBack();
  };

  const getPlannedDate = () => {
    if (currentDeal && currentDeal?.['Projected Move In Date']) {
      const date = new Date(currentDeal['Projected Move In Date']);
      const reqDate =
        date.toLocaleDateString('en-US', { day: 'numeric' }) +
        '-' +
        date.toLocaleDateString('en-US', { month: 'short' }) +
        '-' +
        date.toLocaleDateString('en-US', { year: 'numeric' });

      return reqDate;
    }
  };

  return (
    <>
      {IsSpinner && <Spinner />}
      <ContainerBlock>
        {' '}
        {IsSpinner && <Spinner />}
        <ContainerContentBlock>
          <LogoBlock>
            <img src={logo} />
          </LogoBlock>
          <BannerBlock isFirst>
            <img src={headerMobileImg} alt="" />
          </BannerBlock>

          <ChildBlock index={1}>
            <LogoBlockChild>
              <img src={logo} />
            </LogoBlockChild>
            <Title>
              <DescriptionOutlinedIcon />
              Agile Real Estate Solutions for
            </Title>
            <ClientTitle>{currentDeal?.['Client Name']?.[0]}</ClientTitle>
            <Subtitle>{getSurveyName() ? getSurveyName() : ''}</Subtitle>
          </ChildBlock>

          {surveyData && surveyData?.dealId === constNames.DEAL_ID && (
            <ChildBlock index={3}>
              <ClientRequirements>
                <div className="headingBlock">Client requirements:</div>

                <ClientBlock>
                  <Column>
                    <Subtitle>Desks needed</Subtitle>
                    <Subtitle>10-40 desks</Subtitle>
                  </Column>
                  <Column>
                    <Subtitle>Move in date</Subtitle>
                    <Subtitle>Immediate</Subtitle>
                  </Column>
                </ClientBlock>
              </ClientRequirements>
            </ChildBlock>
          )}

          {surveyData && surveyData?.dealId !== constNames.DEAL_ID && (
            <ChildBlock index={3}>
              <ClientRequirements>
                <div className="headingBlock">Client Requirements:</div>
                <ClientBlock>
                  <Column>
                    <Subtitle>Desks needed</Subtitle>
                    <Subtitle>
                      {currentDeal?.['Projected Size']}
                      {currentDeal?.['Max Projected Size'] &&
                        currentDeal?.['Max Projected Size'] > 0 &&
                        currentDeal?.['Max Projected Size'] !== currentDeal?.['Projected Size'] && (
                          <span> - {currentDeal?.['Max Projected Size']}</span>
                        )}
                    </Subtitle>
                  </Column>
                  <Column>
                    <Subtitle>Move in date</Subtitle>
                    <Subtitle>{getPlannedDate()}</Subtitle>
                  </Column>
                </ClientBlock>
              </ClientRequirements>
            </ChildBlock>
          )}

          <FlexpertsBlock isFirst>
            <Title> Your Flexperts:</Title>
            {emails && emails?.length > 0 && (
              <>
                {emails.map((email, indexMailId) => (
                  <FlexpertsEmail
                    className="flexpertsEmail"
                    key={'email_' + `${indexMailId}` + email}
                  >
                    {email}
                  </FlexpertsEmail>
                ))}
              </>
            )}
            <ContinueBlock>
              {location?.state?.isCamePre ? (
                <BackWrapperTag>
                  <div className="back-tag-elem" onClick={goBack}>
                    <ArrowBackOutlinedIcon />
                  </div>
                  Back
                </BackWrapperTag>
              ) : (
                <>
                  Continue{' '}
                  <Link
                    to={{
                      pathname: `${AppRoutes.MOBILE_BASE}/${surveyId}/totaloptions`,
                    }}
                  >
                    {' '}
                    <ArrowForwardOutlinedIcon />
                  </Link>
                </>
              )}
            </ContinueBlock>
          </FlexpertsBlock>

          <ContinueLandScapeBlock>
            {location?.state?.isCamePre ? (
              <BackWrapperTag>
                <div className="back-tag-elem" onClick={goBack}>
                  <ArrowBackOutlinedIcon />
                </div>
                Back
              </BackWrapperTag>
            ) : (
              <>
                Continue{' '}
                <Link
                  to={{
                    pathname: `${AppRoutes.MOBILE_BASE}/${surveyId}/totaloptions`,
                  }}
                >
                  {' '}
                  <ArrowForwardOutlinedIcon />
                </Link>
              </>
            )}
          </ContinueLandScapeBlock>
        </ContainerContentBlock>
      </ContainerBlock>
    </>
  );
}

const ContainerBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  background-color: #012a2d;
  color: #fff;
`;
const ContainerContentBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  line-height: 40px;
  font: Calibre-R;
  grid-gap: 10px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    grid-gap: 10px 20px;
  }
`;

const BannerBlock = styled.div`
  width: 100%;
  img {
    width: 100%;
    margin: 0 0 10px;
  }
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    width: 40%;
    order: 3;
  }

  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    width: 80%;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: 50%;
    order: 1;
  }
`;
const ChildBlock = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    width: 50%;
    order: ${({ index }) => index};
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    margin-top: 20px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: 40%;
    order: ${({ index }) => index + 1};
  }
`;

const LogoBlock = styled(ChildBlock)`
  justify-content: center;
  text-align: center;
  color: #fff;
  margin: 10px 0 0;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    display: none;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    margin: 10px 0 20px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    display: block;
    margin-bottom: 30px;
    width: 100%;
  }
`;

const LogoBlockChild = styled.div`
  justify-content: center;
  text-align: center;
  color: #fff;
  margin: 10px 0;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.POTRAIT}) {
    display: none;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    display: none;
  }
`;

const FlexpertsBlock = styled(ChildBlock)`
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    order: 4;
    width: 40%;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    order: 3;
    width: 50%;
  }
`;
const BackWrapperTag = styled.div`
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;

  padding: 4px 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  & .back-tag-elem {
    display: flex;
    border: solid 2px #fff;
    border-radius: 20px;
    margin-right: 15px;
    padding: 5px 20px;
    svg {
      color: #fff;
    }
  }
`;

const ContinueLandScapeBlock = styled(ChildBlock)`
  display: none;

  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    order: 5;
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 30px 0;
    align-items: center;
    a {
      display: flex;
      border: solid 2px #fff;
      border-radius: 20px;
      margin-left: 15px;
      padding: 5px 20px;
      svg {
        color: #fff;
      }
    }
  }
`;

const FlexpertsEmail = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
`;

const ClientTitle = styled.div`
  margin: 10px 0;
  font-size: 28px;
  line-height: 40px;
  color: #dbd99a;
  font-family: FinancierDisplay !important;
`;

const ClientRequirements = styled.div`
  background-color: #435254;
  margin: 0 auto;
  width: 100%;
  .headingBlock {
    width: 100%;
    justify-content: center;
    border-bottom: solid 1px #dfe6e5;
    margin: 10px 0 10px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    width: 50%;
  }
`;

const ClientBlock = styled.div`
  gap: 45px;
  margin-bottom: 15px;
  display: flex;
  padding: 15px;
  justify-content: center;

  & .columnList {
    list-style: circle;
    li {
      text-align: left;
      font-size: 14px;
      line-height: 25px;
    }
  }
`;
const Column = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  flex: ${({ flex }) => flex};
  max-width: ${({ maxWidth }) => maxWidth};
`;

const Title = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  svg {
    margin-right: 10px;
  }
`;

const Subtitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
`;

const ContinueBlock = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
  align-items: center;
  a,
  .arrow-wrapper-button {
    display: flex;
    border: solid 2px #fff;
    border-radius: 20px;
    margin-left: 15px;
    padding: 5px 20px;
    svg {
      color: #fff;
    }
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    margin-top: 50px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    display: none;
  }
`;

export default MobileCoverPageComponent;
